import moment from "moment";
import React, { useEffect, useState } from "react";
import useNearScreen from "../../../../../hooks/useNearScreen";
import Photo from "./Photo";
import { round } from "lodash";
import PropTypes from "prop-types";
import { getBodywweightAndUnit } from "../../../../../utils/converters/convert-units";

const TimeLIneItem = (
  {
    stat,
    type,
    choosing,
    selectPhotos,
    selectedPhotos,
    handlePreviewModal,
    expandedList,
    isDragging,
  },
  { locals }
) => {
  const {
    activeUser: { units },
  } = locals;
  const { isNearScreen, elementRef } = useNearScreen();
  const [selected, setSelected] = useState(false);
  const handleClick = () => {
    selectPhotos(stat, type);
  };

  useEffect(() => {
    if (selectedPhotos.some((item) => item.stat === stat && item.key === type))
      setSelected(true);
    else setSelected(false);
  }, [selectedPhotos, stat]);
  return (
    <article
      ref={elementRef}
      style={{ cursor: isDragging ? "grabbing" : "grab" }}
    >
      {isNearScreen && (
        <>
          <div
            onClick={
              !choosing
                ? () => handlePreviewModal(type, stat.bodyPhotos[type]?.s3Path)
                : null
            }
            className="selectable"
            style={!choosing ? { cursor: "pointer" } : {}}
          >
            <Photo
              src={stat.bodyPhotos[type]?.s3Path}
              className={`progress-photo${expandedList ? " expanded" : ""}${
                expandedList && expandedList !== type ? " phidden" : ""
              }`}
            />

            {(selected || (choosing && selectedPhotos.length < 2)) && (
              <div
                className={`progress-item-overlay ${
                  selected ? "selected" : ""
                }`}
                onClick={handleClick}
              >
                <img
                  src={
                    !selected
                      ? "/img/new-icons/tick-circle-outline-white.svg"
                      : "/img/new-icons/close-circle-outline-white.svg"
                  }
                />
                <h2>{selected ? "Deselect" : "Select"}</h2>
              </div>
            )}
          </div>
          <footer>
            <time>
              {moment(stat.utcDate, "YYYYMMDD").format("MMM D, YYYY")}
            </time>
            <p>
              <b>
                {stat.bodyWeight
                  ? getBodywweightAndUnit(stat.bodyWeight, units)
                  : "- "}
              </b>
            </p>
          </footer>
        </>
      )}
    </article>
  );
};
TimeLIneItem.contextTypes = { locals: PropTypes.object };

export default TimeLIneItem;
